(function(){
    'use strict'

    angular.module('app.core')
    .factory('PreventTemplateCacheInterceptor', PreventTemplateCacheInterceptor);

    PreventTemplateCacheInterceptor.$inject = ['planillasVersion'];

    function PreventTemplateCacheInterceptor(planillasVersion) {
        
        var preventTemplateCacheInterceptor = {  
            request: function (config) {  
                
                if (config.url.indexOf('uib') === -1 && config.url.indexOf('.html') !== -1) {
                    config.url = config.url + '?t=' + planillasVersion;
                  }

                return config;  
            } 
        };  
  
        return preventTemplateCacheInterceptor;  
    }
})();